"use client";

import React from "react";
import EventTicker from "@/components/common/EventTicker";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
import StickyFooter from "@/components/newPageComponent/CommonSection/StickyFooter";
import NewInactivityPopup from "@/components/newPageComponent/cma-new/main/new/NewInactivityPopup";
import InfoTicker from "@/components/newPageComponent/cpa-new/course/InforTicket";
import MilesCpaBanner from "@/components/newPageComponent/cpa-new/milescpa/MilesCpaBanner";
import MilesCPAWhyChooseMiles from "@/components/newPageComponent/cpa-new/milescpa/MilesCPAWhyChooseMiles";
import MIlesCpaCoaching from "@/components/newPageComponent/cpa-new/milescpa/MIlesCpaCoaching";
import MilesCpaContactUS from "@/components/newPageComponent/cpa-new/milescpa/MilesCpaContactUS";
import MilesCpaFAQ from "@/components/newPageComponent/cpa-new/milescpa/MilesCpaFAQ";
import PreferredSourceBanner from "@/components/blogs/PreferredSourceBanner";

const PageContent: React.FC = () => {
  return (
    <>
      <div className="w-full bg-white">
        <EventTicker />
        <GlobalHeaderNew />
        <MilesCpaBanner />
        <InfoTicker
          items={[
            {
              highlight: "100+",
              suffix: "  University Partners",
            },
            { highlight: "600+", suffix: " Employer Collaborations" },
            { highlight: "1,000+", suffix: " Students Placed in the U.S." },
            { highlight: "70,000+", suffix: " Global Alumni" },
            { highlight: "", suffix: " Global Career Pathways" },
          ]}
        />
        <MilesCPAWhyChooseMiles />

        <MIlesCpaCoaching />
        <PreferredSourceBanner />
        <MilesCpaContactUS />
        <MilesCpaFAQ />

        <GlobalFooter />
        <StickyFooter pageName="CPA" courseID={1} />
        <NewInactivityPopup pageName="CPA" courseId={1} delay={7000} />
      </div>
    </>
  );
};

export default PageContent;
